import ReactDOM from "react-dom/client";

import { installPreloadErrorHandler } from "igfd-commons/src/utils/preloadErrorHandler";

import App from "./App";
import { startAnalytics } from "./monitoring/mixpanel";
import { startMonitoring } from "./monitoring/rum";

// if cookie consent is not set, this will not do anything.
// however we want to start this, here for cases where the user
// has already accessed cookies and is coming back to the site.
startMonitoring();
startAnalytics();

installPreloadErrorHandler();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);
